import React from 'react';

// components
import { Link } from 'src/components/Inputs';
import ArrowRightSingleSmall from 'src/components/SVGs/Icons/ArrowRightSingleSmall';
import Image from 'src/components/Image';

const ContentCard = (props) => {return (
  <React.Fragment>
    <div className="content-cards-container">
      <div className="grid-container">
        {Boolean(props['header-section']) && (
          <React.Fragment>
            <div className="grid-x align-justify">
              <div className="cell small-12 medium-12">
                <h6 className="content-card-label">{props['header-text']}</h6>
              </div>
              <div className="cell small-12 medium-12">
                <h2 className="content-card-title">{props['header-subtext']}</h2>
              </div>
            </div>
          </React.Fragment>
        )}
        <div className="grid-x align-justify grid-margin-x">
          {props['card-count'] === 'two' &&
            props.cards.map((item, i) => {return (
              <React.Fragment key={i}>
              <Link href={item['section-link']}>
                <a className="cell small-12 medium-6 content-card">
                  {item.image && <Image className="content-card-img" src={item.image}/>}
                  <h4 className="regular page-header-subheader">{item['section-header-text']}</h4>
                  <hr className="content-card-divider" />
                  <p dangerouslySetInnerHTML={{ __html: item['section-text'] }} />
                  <p className="content-card-cta">
                    {Boolean(item['section-cta-text']) && (item['section-cta-text'] ? item['section-cta-text'] + ' ' : 'Learn more ')}
                    <ArrowRightSingleSmall />
                  </p>
                </a>
                </Link>
              </React.Fragment>
            )})}
          {props['card-count'] === 'three' &&
            props.cards.map((item, i) => {return (
              <React.Fragment key={i}>
                <Link href={item['section-link']}>
                  <a className="cell small-12 medium-4 content-card">
                    <h4 className="regular page-header-subheader">{item['section-header-text']}</h4>
                    <hr className="content-card-divider" />
                    <p>{item['section-text']}</p>
                    <p className="content-card-cta">
                      {Boolean(item['section-cta-text']) && (
                        <React.Fragment>{item['section-cta-text']} ) : (Learn more</React.Fragment>
                      )}{' '}
                     <ArrowRightSingleSmall />
                    </p>
                  </a>
                </Link>
              </React.Fragment>
            )})}
        </div>
      </div>
    </div>
  </React.Fragment>
)};


export default ContentCard;
